module.exports = __webpack_public_path__ + "static/airplane-54281b50f821cc29b4084741fbe9c963.png";